export default __webpack_public_path__ + "media/images/celeste_rotate_-7c6c5dccf103830821d10709a9c9e6fe.png";